export const couponBg = '#a3e4de';
export const couponColor = '#175956';
export const newCouponBg = '#138486';
export const newCouponColor = '#138486';

export const couponLightboxStyles = {
  couponIcon: {
    height: '20px',
    verticalAlign: 'middle',
    paddingRight: '5px',
  },
};

export const lightboxStyles = {
  lightbox: {
    background: '2px solid #CCC',
  },
  overlay: {
    position: 'fixed',
    backgroundColor: 'rgba(0,0,0,0.3125)',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    width: '100%',
    height: '100%',

    zIndex: 9999,
  },
  container: {
    backgroundColor: 'white',
    width: 640,
    fontFamily: 'sans-serif',
  },
  header: {
    backgroundColor: couponBg,
    padding: 10,
    textAlign: 'center',
    color: couponColor,
  },
  title: {
    fontSize: 14,
    marginTop: 20,
    marginBottom: 10,
  },
  body: {
    padding: 20,
    paddingBottom: 0,
  },
  footer: {
    padding: 20,
    background: '#ffffff',
  },
  buttonOk: {
    border: 'none',
    padding: [5, 35],
    color: 'white',
    fontSize: 11,
    background: '#404040',
  },
};
